module.exports = __webpack_public_path__ + "assets/images/12-6byg-4L.jpg";